(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c4-brands"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-c4-brands-carousel]').forEach(function (box) {
      if (box.dataset.c4Init) return;
      box.dataset.c4Init = '1';
      var paused = false, timer;
      function step() {
        if (paused || reduce) return;
        if (box.scrollWidth <= box.clientWidth + 8) return;
        var item = box.querySelector('.c4-brands__item');
        var w = item ? item.getBoundingClientRect().width + 16 : 216;
        var atEnd = box.scrollLeft + box.clientWidth >= box.scrollWidth - 4;
        if (atEnd) { box.scrollTo({ left: 0 }); } else { box.scrollBy({ left: w }); }
      }
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (e) { box.addEventListener(e, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (e) { box.addEventListener(e, function () { paused = false; }, { passive: true }); });
      timer = setInterval(step, 3500);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["same-day-ship-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Code 4 2026-09-02 (task BA) — US FEDERAL HOLIDAYS.
       Until today addBusinessDays() skipped Saturday and Sunday and NOTHING
       else, and there was no holiday calendar anywhere in the theme. So on
       3 July this badge cheerfully promised "ships tomorrow", and did the same
       on the Wednesday before Thanksgiving and on Christmas Eve.

       COMPUTED, NOT A HARDCODED LIST, so it cannot silently expire. A list of
       literal dates is a guard with a shelf life -- the exact failure class this
       repo keeps getting bitten by (see HANDOFF-2026-09-01-verification-and-gates).

       Federal is an approximation of Kroll's Michigan warehouse, which is what
       actually delays a package; their real closure calendar is not in any file
       we hold. Gregory's ruling 2026-09-02. Revisit if a real closure is missed.

       Observed shifts included: a holiday on Saturday is taken Friday, one on
       Sunday is taken Monday, which is when the warehouse is actually shut. */
    var C4_HOLIDAY_CACHE = {};

    function c4Key(d) {
      return d.getUTCFullYear() + '-' + (d.getUTCMonth() + 1) + '-' + d.getUTCDate();
    }

    function c4NthWeekday(y, month, weekday, n) {
      var first = new Date(Date.UTC(y, month, 1));
      var shift = (weekday - first.getUTCDay() + 7) % 7;
      return new Date(Date.UTC(y, month, 1 + shift + (n - 1) * 7));
    }

    function c4LastWeekday(y, month, weekday) {
      var last = new Date(Date.UTC(y, month + 1, 0));
      var shift = (last.getUTCDay() - weekday + 7) % 7;
      return new Date(Date.UTC(y, month + 1, 0 - shift));
    }

    function c4Holidays(y) {
      if (C4_HOLIDAY_CACHE[y]) return C4_HOLIDAY_CACHE[y];
      var out = {};
      // Fixed-date, with the observed shift off a weekend.
      [[0, 1], [5, 19], [6, 4], [10, 11], [11, 25]].forEach(function (md) {
        var d = new Date(Date.UTC(y, md[0], md[1]));
        var wd = d.getUTCDay();
        if (wd === 6) d = new Date(d.getTime() - 86400000);
        else if (wd === 0) d = new Date(d.getTime() + 86400000);
        out[c4Key(d)] = true;
      });
      out[c4Key(c4NthWeekday(y, 0, 1, 3))] = true;    // MLK, 3rd Mon Jan
      out[c4Key(c4NthWeekday(y, 1, 1, 3))] = true;    // Presidents, 3rd Mon Feb
      out[c4Key(c4LastWeekday(y, 4, 1))] = true;      // Memorial, last Mon May
      out[c4Key(c4NthWeekday(y, 8, 1, 1))] = true;    // Labor, 1st Mon Sep
      out[c4Key(c4NthWeekday(y, 9, 1, 2))] = true;    // Columbus, 2nd Mon Oct
      out[c4Key(c4NthWeekday(y, 10, 4, 4))] = true;   // Thanksgiving, 4th Thu Nov
      C4_HOLIDAY_CACHE[y] = out;
      return out;
    }

    // Closed = weekend or federal holiday. The warehouse ships on neither.
    function c4IsClosed(d) {
      var wd = d.getUTCDay();
      if (wd === 0 || wd === 6) return true;
      return !!c4Holidays(d.getUTCFullYear())[c4Key(d)];
    }

    function addBusinessDays(date, days) {
      var d = new Date(date.getTime());
      var added = 0;
      while (added < days) {
        d.setUTCDate(d.getUTCDate() + 1);
        if (!c4IsClosed(d)) added++;
      }
      return d;
    }

    /* The store's calendar day and clock, as UTC-midnight so every business-day
       calculation below is timezone-safe rather than the shopper's local date. */
    function c4Now(tz) {
      var p = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
      }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
      var hour = parseInt(p.hour, 10); if (hour === 24) hour = 0;
      return {
        day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
        hour: hour, minute: parseInt(p.minute, 10), second: parseInt(p.second, 10)
      };
    }

    /* Code 4 2026-09-14: the cutoff is 9 AM PACIFIC / 12 PM EASTERN, noon at Kroll's Michigan dock,
       so the zone is America/New_York. Gregory ruled "9 AM PT / 12 PM ET" on 2026-09-14, reversing
       the noon-Pacific change made the night before ("kroll noon pacific").

       ONE implementation of "when does this ship", shared with the product-level
       availability line via window.C4Ship so the two can never drift apart. */
    function c4ShipInfo(cutoffHour, tz) {
      var now = c4Now(tz);
      var openToday = !c4IsClosed(now.day);
      var shipsToday = openToday && now.hour < cutoffHour;
      var ship = shipsToday ? now.day : addBusinessDays(now.day, 1);
      // Code 4 2026-09-14, Gregory: "for holidays i think we should have a "ships next open
      // business day"", when a holiday delays it: the ship day counting holidays is later than
      // the day counting weekends alone (the Friday before Labor Day after the cutoff, Columbus
      // Day morning). A holiday afternoon delays nothing, so it still names the day. Checkout
      // (c4u-checkout shipping-promise run.js) and the header banner apply the same rule.
      var plain = now.day;
      if (plain.getUTCDay() === 0 || plain.getUTCDay() === 6 || now.hour >= cutoffHour) {
        do { plain = new Date(plain.getTime() + 86400000); } while (plain.getUTCDay() === 0 || plain.getUTCDay() === 6);
      }
      var holidayDelay = ship.getTime() !== plain.getTime();
      var countdown = null;
      if (shipsToday) {
        var left = ((cutoffHour - now.hour) * 3600) - (now.minute * 60) - now.second;
        var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60);
        countdown = h > 0 ? (h + 'h ' + m + 'm') : (m + 'm');
      }
      // Code 4 2026-09-13: "today" and "tomorrow" are the SHOPPER's days. The ship date
      // comes from the warehouse calendar above, but at 10 pm on a Sunday in California it
      // is already Monday in Michigan, and the box said "ships today" on a Sunday night.
      // shipsToday now means "ships on the shopper's today"; countdown still runs whenever
      // an order placed now makes the warehouse's cutoff.
      var localNow = new Date();
      var ahead = Math.round((ship - Date.UTC(localNow.getFullYear(), localNow.getMonth(), localNow.getDate())) / 86400000);
      var label;
      if (holidayDelay) {
        label = 'next open business day';
      } else if (ahead <= 0) {
        label = 'today';
      } else if (ahead === 1) {
        label = 'tomorrow';
      } else {
        label = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long' }).format(ship);
      }
      return { shipsToday: label === 'today', countdown: countdown, label: label, shipDate: ship, holidayDelay: holidayDelay };
    }

    window.C4Ship = { shipInfo: c4ShipInfo, isClosed: c4IsClosed, addBusinessDays: addBusinessDays };

    /* Code 4 2026-09-13: Draft C on the product page, two tiles and a bar.
       Gregory chose the solid stock tile and the sentence-case wording. Only
       the main product badge is drawn this way (syncVariant marks it); the
       collection cards keep the compact line. */
    var C4SB_CHECK = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="#fff"/><path d="M6 10.4l2.6 2.6L14 7.6" stroke="#166534" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var C4SB_ALERT = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 2.2l8.4 14.8H1.6z" fill="#b42318" stroke="#b42318" stroke-linejoin="round"/><rect x="9.1" y="7.2" width="1.8" height="5.2" rx=".9" fill="#fff"/><circle cx="10" cy="14.5" r="1.05" fill="#fff"/></svg>';
    var C4SB_WAIT = '<p><b>Made to order.</b> We typically see these orders fulfilled in 40 to 50 business days, but please understand that once the manufacturer has the order, it is out of our hands.</p>';
    var C4SB_BAR = '<div class="c4sb__bar">' + C4SB_ALERT + 'FINAL SALE <span>&middot; not returnable or refundable</span></div>';
    var C4SB_FS_MTO = '<details class="c4sb__fs"><summary class="c4sb__bar">' + C4SB_ALERT +
      'FINAL SALE <span>&middot; no returns or refunds</span><span class="c4sb__more">What to expect</span></summary>' +
      '<div class="c4sb__body">' + C4SB_WAIT +
      '<p class="c4sb__rule"><u>Final sale: no refunds, returns, exchanges or cancellations.</u></p></div></details>';
    var C4SB_WTE = '<details class="c4sb__fs c4sb__fs--plain"><summary class="c4sb__plain">What to expect</summary>' +
      '<div class="c4sb__body">' + C4SB_WAIT + '</div></details>';

    function c4sbTile(t, cls) {
      return '<div class="c4sb__tile c4sb__tile--' + cls + '"><small>' + (t.check ? C4SB_CHECK : '') + t.label + '</small>' +
        '<strong' + (t.long ? ' class="c4sb__long"' : '') + '>' + t.big + '</strong>' +
        (t.sub ? '<span>' + t.sub + '</span>' : '') + '</div>';
    }

    // Redraw only when the content changes, so an open "What to expect" stays
    // open through the minute refresh and the variant poll.
    function c4sbRender(textEl, stockTile, arriveTile, extra) {
      var key = [stockTile.kind, stockTile.big, stockTile.sub, arriveTile.big, arriveTile.sub || '', extra.length]
        .join('|').replace(/"/g, '');
      var first = textEl.firstElementChild;
      if (first && first.getAttribute('data-c4sb') === key) return;
      textEl.innerHTML = '<div class="c4sb__wrap" data-c4sb="' + key + '"><div class="c4sb__tiles">' +
        c4sbTile(stockTile, stockTile.kind) + c4sbTile(arriveTile, 'arrive') + '</div>' + extra + '</div>';
    }

    // Tiered stock label, mirroring the Liquid logic above (round DOWN).
    function tierLabel(qty) {
      if (qty < 10) return { label: 'Hurry — only ' + qty + ' left!', low: true };
      if (qty < 25) return { label: '10+ in stock', low: false };
      if (qty < 50) return { label: '25+ in stock', low: false };
      return { label: '50+ in stock', low: false };
    }

    // A badge is variant-aware only if the server flagged it AND it is not
    // sitting inside a product card (so related-product cards on a PDP keep
    // their own server-rendered state).
    function isVariantAware(el) {
      if (el.dataset.variantAware !== '1') return false;
      if (el.closest('.product-grid__item, .card-product, .product-card, .card, .resource-card')) return false;
      return true;
    }

    function getVariantMap(el) {
      if (el._c4variants) return el._c4variants;
      var map = {};
      var s = el.querySelector('.same-day-ship-badge__variants');
      if (s) {
        try {
          JSON.parse(s.textContent || '[]').forEach(function (v) { map[String(v.id)] = v; });
        } catch (e) {}
      }
      el._c4variants = map;
      return map;
    }

    function selectedVariantId() {
      var input = document.querySelector('product-form-component input[name="id"]')
               || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')
               || document.querySelector('input[name="id"][ref="variantId"]');
      return input && input.value ? String(input.value) : null;
    }

    // Stockable (N / Y / '') for the CURRENTLY selected variant. Reads the
    // per-variant value from the variant JSON; falls back to the product-level
    // data-stockable when there is no per-variant data (e.g. compact cards).
    function currentStockable(el) {
      var map = getVariantMap(el);
      var vid = selectedVariantId() || el.dataset.defaultVariant;
      var v = vid ? map[String(vid)] : null;
      return (v && v.stk) ? v.stk : (el.dataset.stockable || '');
    }

    // The add-to-cart button is Horizon's authoritative purchasability signal:
    // it updates correctly even for invalid option combos (where the hidden
    // variant id can stay on the last valid variant). Returns true if the live
    // button is NOT a purchasable "add to cart" (disabled / sold-out / available
    // to order), false if it IS purchasable, null if it can't be found.
    function addToCartDisabled() {
      var scope = document.querySelector('product-form-component') || document;
      var btn = scope.querySelector('button[name="add"]')
             || scope.querySelector('add-to-cart-component button')
             || scope.querySelector('.product-form-buttons button[type="submit"]')
             || scope.querySelector('[ref="addToCartButton"]');
      if (!btn) return null;
      var off = btn.disabled === true || btn.getAttribute('aria-disabled') === 'true';
      if (!off) return false;
      // A button that is disabled but STILL LABELLED "add to cart" is merely
      // busy: Horizon disables it while the variant fetch is in flight. Reading
      // that transient state as unpurchasable made in-stock variants render the
      // 40-50 day backorder ETA -- an in-stock boot showed "In stock - ships
      // now" and "Delivery expected Oct 1 - Oct 11" together (2026-08-22,
      // mobile, where the fetch window is longest).
      //
      // Real unavailability RELABELS the button (Sold out / Unavailable /
      // Select options), so only those are authoritative. Returning null here
      // means "unknown", which the callers already treat as "do not override
      // the variant JSON" -- so invalid option combos still win over a stale
      // variant id, which is why the button check exists at all.
      var label = (btn.textContent || '').trim().toLowerCase();
      if (!label || label.indexOf('add to cart') !== -1
                 || label.indexOf('add to bag') !== -1) return null;
      return true;
    }

    function variantInStock(v) {
      return !!v && v.tracked === true && parseInt(v.qty, 10) > 0;
    }

    // Tracked but no on-hand stock = special-order / backorder. We intentionally
    // do NOT require Shopify's `available` flag here: special-order sizes report
    // available:false (deny + 0 qty) yet are still orderable, so they should show
    // the "Available to order" message rather than vanish.
    function variantBackorder(v) {
      return !!v && v.tracked === true && parseInt(v.qty, 10) <= 0;
    }

    // Out-of-stock / backorder variant: show an "Available to order" message
    // (with the special-order window) instead of hiding the badge.
    function renderBackorder(el) {
      var textEl = el.querySelector('.same-day-ship-badge__text');
      if (!textEl) return;
      el.classList.remove('same-day-ship-badge--low');
      el.classList.remove('same-day-ship-badge--next-day');
      el.classList.add('same-day-ship-badge--backorder');
      var stockable = currentStockable(el);
      // WWOF lane, 2026-09-14: a size on order from the maker carries its ship
      // date in custom.ships_by (the variant JSON's "by"). Show that date, not the
      // special-order window below. Empty on every product outside lane:wwof.
      var byMap = getVariantMap(el);
      var byVid = selectedVariantId() || el.dataset.defaultVariant;
      var byV = byVid ? byMap[String(byVid)] : null;
      var byDate = (byV && byV.by) ? new Date(String(byV.by) + 'T00:00:00Z') : null;
      if (byDate && !isNaN(byDate.getTime())) {
        var byText = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }).format(byDate);
        el.classList.remove('same-day-ship-badge--unavailable');
        if (el.classList.contains('c4sb')) {
          c4sbRender(textEl,
            { kind: 'mto', label: 'On order', big: 'Available to order', sub: 'from the maker' },
            { label: 'Ships by', big: byText, long: true },
            '');
          el.hidden = false;
          return;
        }
        textEl.innerHTML = '<span class="same-day-ship-badge__stock-hero">Available to order</span>' +
          '<span class="same-day-ship-badge__ship-line"><strong>Ships by ' + byText + '</strong></span>';
        el.hidden = false;
        return;
      }
      // Code 4 2026-09-13: 40 to 50 BUSINESS days, the promise the legend, the
      // lead time and checkout all make, counted on the same holiday calendar as
      // the in-stock date. The Liquid attributes are kept only as the fallback if
      // the date cannot be worked out here.
      var start = el.dataset.specialStart || '';
      var end = el.dataset.specialEnd || '';
      try {
        var c4Today = c4Now(el.dataset.cutoffTz || 'America/New_York').day;
        var c4Md = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' });
        start = c4Md.format(addBusinessDays(c4Today, 40));
        end = c4Md.format(addBusinessDays(c4Today, 50));
      } catch (e) {}
      el.classList.remove('same-day-ship-badge--unavailable');
      if (el.classList.contains('c4sb')) {
        c4sbRender(textEl,
          { kind: 'mto', label: 'Special order', big: 'Made to order', sub: 'by the manufacturer' },
          // Code 4 2026-09-14: Gregory's wording, made-to-order sizes only; the in-stock tile keeps "Arrives by".
          { label: 'Expected delivery*', big: (start && end) ? start + ' to ' + end : 'Date to follow', long: true,
            sub: '*This is only an estimate. Delays may occur depending on the manufacturer.' },
          stockable === 'N' ? C4SB_FS_MTO : C4SB_WTE);
        el.hidden = false;
        return;
      }
      var hero = '<span class="same-day-ship-badge__stock-hero">Available to order</span>';
      // Calendar date only — no "~40-50 days" relative wording.
      var arriveLine = (start && end)
        ? '<span class="same-day-ship-badge__ship-line"><strong>Delivery expected ' + start + ' – ' + end + '</strong></span>'
        : '';
      var disclosure = (stockable === 'N')
        ? '<span class="same-day-ship-badge__disclosure">Special-order items are not returnable or refundable</span>'
        : '';
      textEl.innerHTML = hero + arriveLine + disclosure;
      el.hidden = false;
    }

    // The selected variant cannot be bought AT ALL -- deny + 0, or no inventory
    // level at the warehouse for the online store to ship from.
    //
    // Deliberately shows NO delivery window. A date here is a promise the
    // Add-to-cart button then refuses, and a promise we break is worse than no
    // promise. Wording matches c4-card-availability's third state so the grid,
    // the picker tile and this banner all say the same word.
    function renderUnavailable(el) {
      var textEl = el.querySelector('.same-day-ship-badge__text');
      if (!textEl) return;
      el.classList.remove('same-day-ship-badge--low');
      el.classList.remove('same-day-ship-badge--next-day');
      el.classList.remove('same-day-ship-badge--backorder');
      el.classList.add('same-day-ship-badge--unavailable');
      textEl.innerHTML =
        '<span class="same-day-ship-badge__stock-hero">Unavailable</span>' +
        '<span class="same-day-ship-badge__ship-line">This combination cannot be ordered. Pick another option, or contact us and we will try to source it.</span>';
      el.hidden = false;

    }

    // Point the badge at the currently selected variant: show + relabel for
    // in-stock variants, hide for out-of-stock / backorder variants.
    // "Select options" does not mean unavailable -- it means the shopper has not
    // finished choosing. Horizon uses that label only for an incomplete
    // selection (real unavailability says Sold out / Unavailable), and the
    // variant picker's own completeness gate sets the same label while it holds
    // the hidden variant id blank.
    function selectionIncomplete() {
      var scope = document.querySelector('product-form-component') || document;
      var btn = scope.querySelector('button[name="add"]')
             || scope.querySelector('add-to-cart-component button')
             || scope.querySelector('.product-form-buttons button[type="submit"]')
             || scope.querySelector('[ref="addToCartButton"]');
      if (!btn) return false;
      return (btn.textContent || '').trim().toLowerCase()
               .indexOf('select options') !== -1;
    }

    // Store availability note (2026-09-13). The per-size "store" flag is
    // custom.in_store, written hourly by code/store_stock_flag.py from Glendora
    // counter stock. Liquid renders both texts; this only picks one.
    function syncStoreNote(el) {
      var note = el.nextElementSibling;
      if (!note || !note.hasAttribute('data-c4-store-note')) return;
      if (!isVariantAware(el)) { note.hidden = true; return; }
      var map = getVariantMap(el);
      var list = Object.keys(map).map(function (k) { return map[k]; });
      var v = null;
      if (!selectionIncomplete()) {
        var vid = selectedVariantId() || el.dataset.defaultVariant;
        v = vid ? map[String(vid)] : null;
      }
      var inStore;
      if (v) {
        // Not on the shelf and not orderable online: say nothing rather than
        // "Only available online" next to an Unavailable banner.
        if (v.available === false && v.store !== true) { note.hidden = true; return; }
        inStore = v.store === true;
      } else {
        // No size chosen yet: speak only when every size would say the same.
        var n = list.filter(function (x) { return x.store === true; }).length;
        if (!list.length || (n > 0 && n < list.length)) { note.hidden = true; return; }
        inStore = n === list.length;
      }
      note.querySelector('.c4-store-note__instore').hidden = !inStore;
      note.querySelector('.c4-store-note__online').hidden = inStore;
      note.hidden = false;
    }

    function syncVariant(el) {
      el.classList.add('c4sb');
      syncStoreNote(el);
      // Nothing chosen yet -> assert nothing. The fallback below is
      // data-default-variant (`selected_or_first_available_variant`), which on a
      // size run is the SMALLEST size and is usually 0 on hand -- so reading it
      // as the shopper's choice opened every multi-option product page with
      // "AVAILABLE TO ORDER / Delivery expected Oct 1 - Oct 11" above the buy
      // button, including boots whose common sizes ship Monday (2026-08-22).
      // The variant status line already stays silent until the selection is
      // complete; this makes the badge agree with it instead of guessing.
      if (selectionIncomplete()) {
        el.hidden = true;
        return;
      }
      var map = getVariantMap(el);
      var vid = selectedVariantId() || el.dataset.defaultVariant;
      var v = vid ? map[String(vid)] : null;
      var disabled = addToCartDisabled(); // true / false / null(unknown)

      // Only show the in-stock urgency badge when the variant has real stock
      // AND the live button is actually purchasable. This keeps the badge in
      // agreement with the button even for invalid option combos (where the
      // hidden variant id can be stale).
      if (variantInStock(v) && disabled !== true) {
        var qty = parseInt(v.qty, 10);
        var tier = tierLabel(qty);
        el.dataset.stock = String(qty);
        el.dataset.stockLabel = tier.label;
        el.dataset.stockLow = tier.low ? '1' : '0';
        el.classList.toggle('same-day-ship-badge--low', tier.low);
        el.hidden = false;
        updateBadge(el);
      } else if (v && v.available === false) {
        // MUST be tested BEFORE the backorder branch. `available:false` means
        // deny + 0, or a variant with no inventory level at the warehouse --
        // either way checkout REFUSES it. Sending it to renderBackorder printed
        // "Available to order · Delivery expected <date>" above an Add-to-cart
        // button Horizon had already greyed out. On the Safariland 77 that was
        // 79 of 82 variants promising a delivery date for something unbuyable.
        //
        // A CONTINUE variant at 0 qty reports available:TRUE -- that is what
        // makes genuine backorder work -- so real special orders still reach
        // renderBackorder below and are unaffected.
        renderUnavailable(el);
      } else if (v || disabled === true) {
        renderBackorder(el);
      } else {
        el.hidden = true;
      }
    }

    function updateBadge(el) {
      const cutoffHour = parseInt(el.dataset.cutoffHour || '12', 10);
      const tz = el.dataset.cutoffTz || 'America/New_York';
      const transit = el.dataset.transit || '3-5 business days';
      const transitDays = parseInt(el.dataset.transitDays || '5', 10);
      const stock = parseInt(el.dataset.stock || '0', 10);
      const stockLabel = el.dataset.stockLabel || (stock + ' in stock');
      const stockLow = el.dataset.stockLow === '1';
      const stockable = currentStockable(el);
      const textEl = el.querySelector('.same-day-ship-badge__text');
      if (!textEl) return;

      const now = new Date();
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });
      const parts = fmt.formatToParts(now).reduce((acc, p) => {
        acc[p.type] = p.value;
        return acc;
      }, {});
      const weekday = parts.weekday;
      let hour = parseInt(parts.hour, 10);
      if (hour === 24) hour = 0;
      const minute = parseInt(parts.minute, 10);
      const second = parseInt(parts.second, 10);

      const weekdayMap = { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 };
      const dayIdx = weekdayMap[weekday];

      const isWeekday = dayIdx >= 1 && dayIdx <= 5;
      const beforeCutoff = hour < cutoffHour;

      el.classList.remove('same-day-ship-badge--next-day');
      el.classList.remove('same-day-ship-badge--backorder');

      const stockHero = '<span class="same-day-ship-badge__stock-hero">' + stockLabel + '</span>';

      let moreLine = '';
      if (stockable === 'N') {
        moreLine = '<span class="same-day-ship-badge__more">Need more? Additional units available to order</span>';
      } else if (stockable === 'Y') {
        moreLine = '<span class="same-day-ship-badge__more">Need more? Contact us</span>';
      }

      const transitLine = '<span class="same-day-ship-badge__transit">' + transit + '</span>';
      const disclosureLine = (stockable === 'N')
        ? '<span class="same-day-ship-badge__disclosure">Special-order items are not returnable or refundable</span>'
        : '';

      // Determine the ship date (in the customer's local time, which is fine
      // for an estimate), then add the transit window's upper bound so we
      // under-promise / over-deliver.
      // Task BA: one shared calculation, holiday-aware. `isWeekday` and
      // `beforeCutoff` above are left in place because other branches read them.
      const info = c4ShipInfo(cutoffHour, tz);
      let shipDate = info.shipDate;
      let shipsToday = info.shipsToday;
      const deliverBy = addBusinessDays(shipDate, transitDays);
      const deliverStr = new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
      }).format(deliverBy);
      const deliverLine = '<span class="same-day-ship-badge__deliver">Est. delivery by ' + deliverStr + '</span>';

      if (el.classList.contains('c4sb')) {
        el.classList.remove('same-day-ship-badge--unavailable');
        var c4sbStock = stock < 10
          ? { kind: 'low', label: 'Hurry', big: 'Only ' + stock + ' left', sub: 'in stock' }
          : { kind: 'in', label: 'In stock', check: true, big: stock < 25 ? '10+' : (stock < 50 ? '25+' : '50+'), sub: 'ready to ship' };
        var c4sbShip = info.countdown ? ('Order in ' + info.countdown + ', ships ' + info.label) : ('Ships ' + info.label);
        c4sbRender(textEl, c4sbStock, { label: 'Arrives by', big: deliverStr, sub: c4sbShip },
          stockable === 'N' ? C4SB_BAR : '');
        return;
      }

      let shipLine;
      if (info.countdown) {
        shipLine = '<span class="same-day-ship-badge__ship-line">Order in <span class="same-day-ship-badge__countdown">' + info.countdown + '</span> &mdash; <strong>ships ' + info.label + '</strong></span>';
        if (!shipsToday) el.classList.add('same-day-ship-badge--next-day');
      } else {
        // Was a hardcoded Fri/Sat/Sun -> "Monday", everything else "tomorrow",
        // which had no idea holidays existed: Wednesday before Thanksgiving
        // promised Thursday. info.label walks to the next genuinely open day.
        shipLine = '<span class="same-day-ship-badge__ship-line">Order now &mdash; <strong>ships ' + info.label + '</strong></span>';
        el.classList.add('same-day-ship-badge--next-day');
      }

      textEl.innerHTML = stockHero + moreLine + shipLine + deliverLine + transitLine + disclosureLine;
    }

    function refreshAll() {
      document.querySelectorAll('.same-day-ship-badge').forEach(function (el) {
        if (isVariantAware(el)) {
          syncVariant(el);
        } else if (!el.hidden) {
          updateBadge(el);
        }
      });
    }

    var lastSig = null;
    function currentSig() {
      return (selectedVariantId() || '') + '|' + addToCartDisabled();
    }
    function onMaybeVariantChange() {
      var sig = currentSig();
      if (sig === lastSig) return;
      lastSig = sig;
      document.querySelectorAll('.same-day-ship-badge').forEach(function (el) {
        if (isVariantAware(el)) syncVariant(el);
      });
    }

    function init() {
      refreshAll();
      lastSig = currentSig();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Variant-change detection (theme-agnostic): react to the shopper's
    // interaction, after a short settle so Horizon has updated the button,
    // plus a low-cost safety poll. We key off variant id + button state, so an
    // invalid combo that only toggles the button (id unchanged) is still caught.
    document.addEventListener('change', function () { setTimeout(onMaybeVariantChange, 200); }, true);
    document.addEventListener('click', function () { setTimeout(onMaybeVariantChange, 200); }, true);
    setInterval(onMaybeVariantChange, 500);

    // Keep the countdown fresh on any visible badge. A product-page badge
    // re-syncs instead: calling updateBadge on it redrew a made-to-order or
    // unavailable box as in stock after a minute (found 2026-09-13).
    setInterval(function () {
      document.querySelectorAll('.same-day-ship-badge:not([hidden])').forEach(function (el) {
        if (isVariantAware(el)) syncVariant(el); else updateBadge(el);
      });
    }, 60000);

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
